import { css } from '@emotion/react'
import { useRouter } from 'next/router'
import { Tab, mq } from 'plume-ui'
import { companyTabLabel } from '@/lib/company'
import { CompanyTabType } from 'types'
import { Navbar } from '../../../../common/Navbar'
import { overseaCompanyTabList } from '../../OverseasCompanyPage'

type Props = {
  activeTab: CompanyTabType | null
}

export const OverseasCompanyTabGroup: React.FC<Props> = (props) => {
  const router = useRouter()

  return (
    <Navbar
      data-test-id="tab-group"
      css={css`
        padding: 7px 16px;
        height: 48px;
        ${mq.large} {
          height: auto;
          padding: 11px 0;
          position: sticky;
          top: 160px;
          z-index: 19;
        }
      `}
    >
      <div
        css={css`
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          white-space: nowrap;
        `}
      >
        <Tab.Group>
          {overseaCompanyTabList.map((tab, i) => (
            <Tab
              key={`oversea-${tab}-${i}`}
              active={props.activeTab == tab}
              href={`${router.query.shortname}#${tab}`}
              css={css`
                ${mq.untilMedium} {
                  font-size: 14px;
                  height: 32px;
                }
              `}
            >
              {companyTabLabel[tab]}
            </Tab>
          ))}
        </Tab.Group>
      </div>
    </Navbar>
  )
}
